<template>
  <ValidationObserver rules="required" v-slot="{ handleSubmit }">
    <RightSideBar
      v-if="isOpen"
      @close="$emit('close')"
      @submit="handleSubmit(handleSave)"
      submit="Save"
      cancel="Cancel"
      button-class="bg-dynamicBackBtn text-white"
      padding="padding: 0 0.75rem"
      :loading="loadingOptions"
    >
      <template v-slot:title>
        <div class="flex items-center text-darkPurple w-full">
          <back-button
            variant="secondary"
            @onClick="$emit('close')"
            class="mr-3"
          />
          <h2 class="font-bold text-lg">Scheme of Service</h2>
        </div>
      </template>

      <div class="pt-1">
        <div class="mb-4">
          <c-select
            placeholder="--Select--"
            variant="w-full"
            label="Job Cadre"
            :options="jobCadreOptions"
            v-model="form.jobClassificationId"
            :rules="['required']"
          />
        </div>

        <div class="mb-4">
          <c-select
            placeholder="--Select--"
            variant="w-full"
            label="Post"
            :options="postOptions"
            v-model="form.designationId"
            :rules="['required']"
          />
        </div>

        <div class="mb-4">
          <label class="label block mb-2">Duties</label>
          <c-textarea
            placeholder="Text Area"
            variant="w-full"
            v-model="form.duties"
          />
        </div>

        <div class="mb-4">
          <p class="label mb-1">Pay Scale</p>
          <div class="readonly-field">
            {{ form.payScale || "------" }}
          </div>
        </div>

        <div class="mb-4">
          <label class="label block mb-2">Basic Entry Qualification</label>
          <c-textarea
            placeholder="Text Area"
            variant="w-full"
            v-model="form.basicEntryQualification"
          />
        </div>

        <div>
          <c-text
            label="Next Grade"
            placeholder="--Enter--"
            variant="w-full h-10"
            v-model="form.nextGrade"
          />
        </div>
      </div>
    </RightSideBar>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import RightSideBar from "@/components/RightSideBar";

export default {
  name: "SchemeServiceDrawer",
  components: {
    ValidationObserver,
    CText,
    CTextarea,
    CSelect,
    BackButton,
    RightSideBar,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loadingOptions: false,
      jobCadreOptions: [],
      postOptions: [],
      form: {
        jobClassificationId: null,
        designationId: null,
        duties: "",
        payScale: "",
        basicEntryQualification: "",
        nextGrade: "",
      },
    };
  },
  watch: {
    isOpen(value) {
      if (!value) {
        return;
      }
      this.resetForm();
      this.loadOptions();
    },
  },
  methods: {
    resetForm() {
      const data = this.initialData || {};
      this.form = {
        jobClassificationId:
          data.jobClassificationId ||
          data.schemeJobClassification?.id ||
          null,
        designationId:
          data.designationId || data.schemeDesignation?.id || null,
        duties: data.duties || "",
        payScale: data.payScale || "",
        basicEntryQualification: data.basicEntryQualification || "",
        nextGrade: data.nextGrade || "",
      };
    },
    async loadOptions() {
      this.loadingOptions = true;
      try {
        const [cadresResponse, designationsResponse] = await Promise.all([
          this.$_getJobClassifications(),
          this.$_getDesignations("source=designations"),
        ]);
        const classifications =
          cadresResponse?.data?.jobClassifications || [];
        this.jobCadreOptions = classifications
          .filter((item) => item.type === "jobCadre")
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
        const designations =
          designationsResponse?.data?.designations || [];
        this.postOptions = designations.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        this.jobCadreOptions = [];
        this.postOptions = [];
      } finally {
        this.loadingOptions = false;
      }
    },
    handleSave() {
      this.$emit("save", {
        ...this.form,
        id: this.initialData?.id || null,
        isEdit: this.isEdit,
      });
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 14px;
  color: #2d3142;
}

.readonly-field {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 4px;
  background: #eeeeee;
  color: #321c3b;
  font-size: 14px;
}
</style>
